import cultureApi from '@/api/culture.api'
import { numtiersCible } from '@/utils/destinataire'

const getDefaultState = () => {
  return {
    cultures: [],
    typesCulture: [],
    culturesGrainePrincipale: [],
    culturesSansMouvement: [],
    repartitionSurface: {},
    repartitionSurfaceGroupe: null,
    repartitionGrandesCultures: {},
    repartitionGrandesCulturesGroupe: null,
    codeCultureDemandee: null
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    cultures (state) {
      return state.cultures
    },
    typesCulture (state) {
      return state.typesCulture
    },
    culturesGrainePrincipale (state) {
      return state.culturesGrainePrincipale
    },
    culturesSansMouvement (state) {
      return state.culturesSansMouvement
    },
    repartitionSurface (state) {
      return state.repartitionSurface
    },
    repartitionSurfaceGroupe (state) {
      return state.repartitionSurfaceGroupe
    },
    repartitionGrandesCultures (state) {
      return state.repartitionGrandesCultures
    },
    repartitionGrandesCulturesGroupe (state) {
      return state.repartitionGrandesCulturesGroupe
    },
    codeCultureDemandee (state) {
      return state.codeCultureDemandee
    }
  },

  mutations: {
    UPDATE_CULTURES (state, cultures) {
      state.cultures = cultures
    },
    UPDATE_TYPES_CULTURE (state, typesCulture) {
      state.typesCulture = typesCulture
    },
    UPDATE_CULTURE_NOM_GRAINE_PRINCIPALE (state, culturesGrainePrincipale) {
      state.culturesGrainePrincipale = culturesGrainePrincipale
    },
    UPDATE_CULTURE_SANS_MOUVEMENT (state, culturesSansMouvement) {
      state.culturesSansMouvement = culturesSansMouvement
    },
    UPDATE_REPARTITION_SURFACE (state, repartitionSurface) {
      state.repartitionSurface = repartitionSurface
    },
    UPDATE_REPARTITION_SURFACE_GROUPE (state, repartitionSurfaceGroupe) {
      state.repartitionSurfaceGroupe = repartitionSurfaceGroupe
    },
    UPDATE_REPARTITION_GRANDES_CULTURES (state, repartitionGrandesCultures) {
      state.repartitionGrandesCultures = repartitionGrandesCultures
    },
    UPDATE_REPARTITION_GRANDES_CULTURES_GROUPE (state, repartitionGrandesCulturesGroupe) {
      state.repartitionGrandesCulturesGroupe = repartitionGrandesCulturesGroupe
    },
    UPDATE_CODE_CULTURE_DEMANDEE (state, codeCultureDemandee) {
      state.codeCultureDemandee = codeCultureDemandee
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },

  actions: {
    findAllTypesCulturesActiveByRs3 ({ commit, rootGetters }, codeGraineRs3) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      return cultureApi.findAllTypesCulturesActiveByRs3(username, anneeRecolte, codeGraineRs3)
        .then(response => {
          commit('UPDATE_TYPES_CULTURE', response)
        })
    },
    getCultures ({ commit, rootGetters }, anneeRecolte) {
      const username = numtiersCible(rootGetters)
      return cultureApi.getAllCulturesByNumtiers(username, anneeRecolte)
        .then(response => {
          commit('UPDATE_CULTURES', response)
        })
    },
    getCulturesSansMouvement ({ commit, rootGetters }, anneeRecolte) {
      const username = numtiersCible(rootGetters)
      return cultureApi.getAllCulturesSansMouvementByNumtiersAndRecolte(username, anneeRecolte)
        .then(response => {
          commit('UPDATE_CULTURE_SANS_MOUVEMENT', response)
        })
    },
    createOrUpdateCulture ({ dispatch, rootGetters }, culture) {
      const username = numtiersCible(rootGetters)
      let promiseUpdate
      if (culture.id) {
        promiseUpdate = cultureApi.updateCulture(username, culture)
      } else {
        promiseUpdate = cultureApi.createCulture(username, culture)
      }
      return promiseUpdate.then(() => dispatch('getCultures', culture.anneeRecolte))
    },
    deleteCulture ({ dispatch, rootGetters }, culture) {
      const username = numtiersCible(rootGetters)
      return cultureApi.deleteCulture(username, culture.id)
        .then(() => dispatch('getCultures', culture.anneeRecolte))
    },
    reset ({ commit }) {
      commit('RESET')
    },
    getPoidsGraineConseilleCulture ({ rootGetters }, data) {
      const username = numtiersCible(rootGetters)
      return cultureApi.getPoidsGraineConseilleCulture(username, data.anneeRecolte, data.codeTypeCulture)
        .then(result => {
          return result
        })
    },
    getLibelleTypeCultureFeuillesGrainePrincipaleByTypeCultureFeuille ({ commit }, data) {
      return cultureApi.getLibelleTypeCultureFeuillesGrainePrincipaleByTypeCultureFeuille(data)
        .then((response) => {
          commit('UPDATE_CULTURE_NOM_GRAINE_PRINCIPALE', response)
          return response
        })
    },
    getRepartitionDesSurfaces ({ commit, rootGetters }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      return cultureApi.getRepartitionDesSurfaces(username, anneeRecolte)
        .then((response) => {
          commit('UPDATE_REPARTITION_SURFACE', response)
          return response
        })
    },
    getRepartitionDesSurfacesGroupe ({ commit, rootGetters }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      const filtres = rootGetters['filtresComparaison/filtresAdherent']
      return cultureApi.getRepartitionDesSurfacesGroupe(username, anneeRecolte, filtres)
        .then((response) => {
          commit('UPDATE_REPARTITION_SURFACE_GROUPE', response)
          return response
        })
    },
    getRepartitionDesGrandesCultures ({ commit, rootGetters }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      return cultureApi.getRepartitionDesGrandesCultures(username, anneeRecolte)
        .then((response) => {
          commit('UPDATE_REPARTITION_GRANDES_CULTURES', response)
          return response
        })
    },
    getRepartitionDesGrandesCulturesGroupe ({ commit, rootGetters }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      const filtres = rootGetters['filtresComparaison/filtresAdherent']
      return cultureApi.getRepartitionDesGrandesCulturesGroupe(username, anneeRecolte, filtres)
        .then((response) => {
          commit('UPDATE_REPARTITION_GRANDES_CULTURES_GROUPE', response)
          return response
        })
    },
    demanderCulture ({ commit }, codeCulture) {
      commit('UPDATE_CODE_CULTURE_DEMANDEE', codeCulture)
    },
    oublierCultureDemandee ({ commit }) {
      commit('UPDATE_CODE_CULTURE_DEMANDEE', null)
    }
  }
}

export default module
